// components
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const ICON_SIZE = {
  width: 22,
  height: 22,
};

const menuConfig = [
  {
    title: 'Home',
    icon: <Iconify icon={'clarity:home-line'} {...ICON_SIZE} />,
    path: '/',
  },
  {
    title: 'About Us',
    icon: <Iconify icon={'ion:business-outline'} {...ICON_SIZE} />,
    path: '/about-us',
  },
  {
    title: 'Education',
    path: '/education',
    icon: <Iconify icon={'cil:education'} {...ICON_SIZE} />,
    children: [
      {
        subheader: 'Academics',
        items: [
          { title: 'Teachers', path: '/education/academics' },
          { title: 'Curriculum', path: '/education/academics' },
          { title: 'Calendar', path: '/education/academics' },
        ],
      },
      {
        subheader: 'Core Programs',
        items: [
          { title: 'Infants', path: '/education/core-programs' },
          { title: 'Toddlers', path: '/education/core-programs' },
          { title: 'Twos', path: '/education/core-programs' },
          { title: 'Preschool', path: '/education/core-programs' },
          { title: 'Pre-K', path: '/education/core-programs' },
        ],
      },
      {
        subheader: 'Growth Programs',
        items: [
          { title: 'School Age', path: '/education/growth-programs' },
          { title: 'Before/After School', path: '/education/growth-programs' },
          { title: 'Drop-in Care', path: '/education/growth-programs' },
          { title: 'Spring Break', path: '/education/growth-programs' },
          { title: 'Summer Camp', path: '/education/growth-programs' },
          { title: 'Learning at home', path: '/education/growth-programs' },
          { title: 'Grow Fit', path: '/education/growth-programs' },
        ],
      },
      {
        subheader: 'Dashboard',
        items: [{ title: 'Dashboard', path: '/auth/login' }],
      },
    ],
  },
  {
    title: 'Events',
    icon: <Iconify icon={'material-symbols:event-outline'} {...ICON_SIZE} />,
    path: '/events',
  },
  {
    title: 'Blog',
    icon: <Iconify icon={'carbon:blog'} {...ICON_SIZE} />,
    path: '/blog',
  },
  {
    title: 'Contact',
    icon: <Iconify icon={'cil:contact'} {...ICON_SIZE} />,
    path: 'contact-us',
  },
];

export default menuConfig;
